"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/esm/createClass"));
var _lodash = _interopRequireDefault(require("lodash"));
var createdInstance = null;
var ThemeManager = /*#__PURE__*/function () {
  function ThemeManager(state) {
    (0, _classCallCheck2.default)(this, ThemeManager);
    this.state = state;
    this.listenForIrcEvents();
    this.varsEl = null;
  }
  (0, _createClass2.default)(ThemeManager, [{
    key: "themeVar",
    value: function themeVar(varName) {
      var _context;
      if (!this.varsEl) {
        this.varsEl = document.querySelector('.kiwi-wrap');
      }
      var styles = window.getComputedStyle(this.varsEl);
      var v = styles.getPropertyValue('--kiwi-' + varName);
      return (0, _trim.default)(_context = v || '').call(_context);
    }
  }, {
    key: "availableThemes",
    value: function availableThemes() {
      return this.state.settings.themes;
    }
  }, {
    key: "currentTheme",
    value: function currentTheme() {
      var state = this.state;
      var currentThemeName = state.setting('theme');
      currentThemeName = currentThemeName.toLowerCase();
      var theme = (0, _find.default)(_lodash.default).call(_lodash.default, state.settings.themes, function (t) {
        var isMatch = t.name.toLowerCase() === currentThemeName;
        return isMatch;
      });

      // If no theme was set, use the first one in our theme list
      if (!theme) {
        theme = state.settings.themes[0];
      }
      return theme;
    }
  }, {
    key: "setTheme",
    value: function setTheme(theme) {
      var theTheme = null;
      if (typeof theme === 'string') {
        // Make sure this theme exists
        theTheme = (0, _find.default)(_lodash.default).call(_lodash.default, this.availableThemes(), function (t) {
          var isMatch = t.name.toLowerCase() === theme.toLowerCase();
          return isMatch;
        });
        if (!theTheme) {
          return;
        }
      } else {
        theTheme = theme;
      }
      this.state.setting('theme', theTheme.name);
      this.state.$emit('theme.change');
    }
  }, {
    key: "reload",
    value: function reload() {
      var theme = this.currentTheme();
      if (!theme) {
        return;
      }
      var url = theme.url;
      if (url.indexOf('cb=') > -1) {
        url = url.replace(/cb=[0-9]+/, function () {
          return 'cb=' + Date.now();
        });
      } else if (url.indexOf('?') > -1) {
        url += '&cb=' + Date.now();
      } else {
        url += '?cb=' + Date.now();
      }
      theme.url = url;
      this.state.$emit('theme.change');
    }
  }, {
    key: "setCustomThemeUrl",
    value: function setCustomThemeUrl(url) {
      var theme = (0, _find.default)(_lodash.default).call(_lodash.default, ThemeManager.instance().availableThemes(), {
        name: 'custom'
      });
      if (theme) {
        theme.url = url;
      }
      if (theme.name === 'custom') {
        this.state.$emit('theme.change');
      }
    }

    // When we get a CTCP 'kiwi theme reload' then reload our theme. Handy for theme devs
  }, {
    key: "listenForIrcEvents",
    value: function listenForIrcEvents() {
      var _this = this;
      this.state.$on('irc.ctcp request', function (event, network) {
        var ctcpType = (event.type || '').toLowerCase();
        if (ctcpType === 'kiwi' && event.message.indexOf('theme reload') > -1) {
          _this.reload();
        }
      });
    }
  }], [{
    key: "themeUrl",
    value: function themeUrl(theme) {
      var parts = theme.url.split('?');
      var url = parts[0];
      var qs = parts[1] || '';
      if (url[url.length - 1] !== '/') {
        url += '/';
      }
      return url + 'theme.css' + (qs ? '?' + qs : '');
    }
  }]);
  return ThemeManager;
}();
exports.default = ThemeManager;
ThemeManager.instance = function instance(state) {
  if (!createdInstance) {
    createdInstance = new ThemeManager(state);
  }
  return createdInstance;
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["ThemeManager"]
window._kiwi_exports.libs.ThemeManager = exports.default ? exports.default : exports;
